import React from "react";
import { HiPlusSm, HiMinusSm } from "react-icons/hi";

// assets
import styles from "@/assets/styles/pages/location-single-page/location-single-page-components.module.scss";


function FloorPlanControls({ zoomIn, zoomOut }: { zoomIn: () => void, zoomOut: () => void }) {

  return (
    <div className={styles["locl-location-floor-plan__controls"]}>
      <span
        onClick={() => zoomOut()}
        className={styles["locl-location-floor-plan__controls-btn"]}
        data-testid="locl-locl-location-floor-plan-zoom-out"
      >
        <HiMinusSm className={styles["locl-location-floor-plan__controls-btn-image"]}/>
      </span>
      <span
        onClick={() => zoomIn()}
        className={styles["locl-location-floor-plan__controls-btn"]}
        data-testid="locl-locl-location-floor-plan-zoom-in"
      >
        <HiPlusSm className={styles["locl-location-floor-plan__controls-btn-image"]}/>
      </span>
    </div>
  );
}

export default FloorPlanControls;
